import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { mapState } from 'vuex';
export default {
  name: 'locale',
  props: {
    islogin: {
      default: false
    }
  },
  computed: {
    ...mapState({
      locale: state => state.setting.locale
    })
  },
  watch: {
    locale: {
      handler(val) {
        var _this$localeList$find;
        this.currentKey = val || 'zh_CN';
        this.modelValue = [val] || ['zh_CN'];
        this.currentName = ((_this$localeList$find = this.localeList.find(i => i.key == this.currentKey)) === null || _this$localeList$find === void 0 ? void 0 : _this$localeList$find.name) || '简体中文';
      },
      immediate: true
    }
  },
  data() {
    return {
      currentName: '简体中文',
      currentKey: 'zh_CN',
      modelValue: ['zh_CN'],
      localeList: [{
        name: '简体中文',
        key: 'zh_CN'
      }, {
        name: '繁體中文',
        key: 'zh_TW'
      }, {
        name: 'English',
        key: 'en_US'
      },
      // {name: 'Русский язык', key: 'ru_RU'},
      {
        name: 'Français',
        key: 'fr_FR'
      }, {
        name: 'español',
        key: 'es_ES'
      }]
    };
  },
  created() {
    // let locale = this.$store.state.setting.locale;
    // this.currentKey = locale || 'zh_CN';
    // this.modelValue = [locale] || ['zh_CN'];
    // this.currentName = this.localeList.find(i => i.key == this.currentKey)?.name || '简体中文';
  },
  methods: {
    changeLocale({
      item,
      key
    }) {
      this.currentKey = key;
      this.modelValue = [key];
      this.currentName = this.localeList[item.index].name;
      this.$store.commit('setting/CHANGE_LOCALE', this.currentKey);
      sessionStorage.setItem('locale', this.currentKey);
      this.$emit('changeLocale');
    }
  }
};